
import $ from 'jquery';

import './assessment';

$(function () {

    // Copy validation max length attributes to input maxlength field automatically, so we only have to define this once on our model validation.
    $('input[data-val-length-max], textarea[data-val-length-max]').each(function () {
        var $this = $(this);
        var data = $this.data();
        $this.attr('maxlength', data.valLengthMax);
    });

});
